import replaceUrlTags from "@root/services/replaceUrlTags";
import cygnusSpriteHtml from "@root/services/icons/cygnusSpriteHtml";

export default function (cell, formatterParams, onRendered) {
  const value = cell.getValue();

  const el = document.createElement('div');
  el.classList.add('d-flex', 'flex-column', 'align-items-center');
  if (!value) {
    const { createRoute } = formatterParams;

    if (createRoute) {
      const href = replaceUrlTags(createRoute, cell.getRow());
      const a = document.createElement('a');
      a.href = href;
      a.innerHTML = cygnusSpriteHtml('file', { variant: 'solid', className: 'text-info' });
      a.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      el.appendChild(a);
    }

    return el;
  }


  let icon = 'x-circle';
  let color = 'warning';

  switch (value.toUpperCase()) {
    case 'ACCEPTED':
      icon = 'check-circle';
      color = 'success';
      break;
    case 'LOST':
      color = 'disabled';
      break;
    case 'CASH':
    case 'REJECTED':
      color = 'info';
      break;
    case 'FINANCE':
    case 'BROKER':
    case 'QUOTE':
      break;
    case 'ESTIMATE':
    default:
      color = 'danger';
      break;
  }

  let iconEl = cygnusSpriteHtml(icon, { variant: 'solid', className: `text-${color}` });


  el.innerHTML = `<div>${iconEl}</div><div>${value.substring(0, 1).toUpperCase()}${value.substring(1).toLowerCase()}</div>`;
  return el;
}
